module.exports = __webpack_public_path__ + "static/img/setting-account.892f64b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Topbar/setting-account.jpg
// module id = 1560
// module chunks = 1